import { AlternativeContactType, validateCPR, } from '@debbie/common/dist/customers/index.js';
import { validateEmail } from '@debbie/common/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import AddressInput from '../AddressInput.js';
import AllLanguagesInput from '../AllLanguagesInput.js';
import Checkbox from '../Checkbox.js';
import CompanySearch from '../CompanySearch.js';
import { Col, Row } from '../Grid/index.js';
import { X } from '../Icons/index.js';
import Input from '../Input.js';
import PhoneInput from '../PhoneInput.js';
import Select from '../Select.js';
import Well from '../Well.js';
const CreateUserOnCustomer = (props) => {
    const { user, onChange, onDetailsChange, onDelete } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Well, { style: { marginBottom: '10px', position: 'relative' } },
        onDelete && (React.createElement(DeleteUser, { className: "delete-user", onClick: onDelete },
            React.createElement(X, null))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement(AllLanguagesInput, { language: user.lang, onChange: (value) => {
                        onChange({ lang: value });
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "6" },
                React.createElement(Select, { options: [
                        { value: 'debtor', label: lang.roles['debtor'] },
                        {
                            value: 'alternative-contact',
                            label: lang.roles['alternative-contact'],
                        },
                    ], selected: [user.relation], onChange: (selected) => {
                        if (selected[0]) {
                            onChange({
                                relation: selected[0],
                            });
                        }
                    } })),
            React.createElement(Col, { width: "6" },
                React.createElement(Checkbox, { placeholder: lang.customers.contact, checked: user.contact, onChange: (e) => onChange({
                        contact: e.target.checked,
                    }) }))),
        user.relation === 'alternative-contact' && (React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement(Select, { label: lang.customers.selectType, options: Object.values(AlternativeContactType).map((type) => ({
                        value: type,
                        label: lang.alternativeContactTypes[type],
                    })), selected: user.details?.type
                        ? [user.details.type]
                        : [], onChange: (selected) => {
                        onDetailsChange({
                            type: selected[0] || null,
                        });
                    } })))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" }, user.relation === 'alternative-contact' ? null : props.isCompany ? (React.createElement(CompanySearch, { placeholder: lang.cases.cvr, onRemoveStatic: () => onDetailsChange({
                    cvr: '',
                }), value: user.details.cvr || '', onChange: (e) => {
                    onDetailsChange({
                        cvr: e.centralRegisterId,
                        email: user.details.email ? user.details.email : e.email,
                        name: user.details.name ? user.details.name : e.name,
                        phone: user.details.phone
                            ? user.details.phone
                            : e.phone
                                ? { locale: '45', number: e.phone }
                                : null,
                        address: user.details.address
                            ? user.details.address
                            : e.address,
                    });
                } })) : (React.createElement(Input, { onChange: (e) => {
                    onDetailsChange({
                        cpr: e.target.value,
                    });
                }, value: user.details.cpr || '', placeholder: lang.cases.cpr, validationErrors: user.details.cpr && !validateCPR(user.details.cpr)
                    ? [lang.customers.errorCPRValidation]
                    : null })))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "6" },
                React.createElement(Input, { value: user.details.name, onChange: (e) => {
                        onDetailsChange({
                            name: e.target.value,
                        });
                    }, placeholder: lang.cases.debtorName })),
            React.createElement(Col, { width: "6" },
                React.createElement(PhoneInput, { phone: user.details.phone || null, onChange: (phone) => {
                        onDetailsChange({
                            phone: phone?.number ? phone : null,
                        });
                    }, placeholder: lang.cases.phone, noSaveOnValid: true }))),
        React.createElement(Row, null,
            React.createElement(Col, { width: "6" },
                React.createElement(AddressInput, { onChange: (address) => {
                        onDetailsChange({
                            address,
                        });
                    }, address: user.details.address, disabled: !!user.details.address, placeholder: lang.cases.address })),
            React.createElement(Col, { width: "6" },
                React.createElement(Input, { value: user.details.email || '', onChange: (e) => {
                        onDetailsChange({
                            email: e.target.value,
                        });
                    }, placeholder: lang.cases.email, validationErrors: user.details.email && !validateEmail(user.details.email)
                        ? [lang.customers.errorEmailValidation]
                        : null })))));
};
export default CreateUserOnCustomer;
export const getNewUser = (tenant, contact) => ({
    contact,
    details: {
        name: '',
        email: '',
        phone: null,
        address: null,
        cvr: null,
        cpr: null,
    },
    lang: tenant.lang,
    relation: 'debtor',
});
const DeleteUser = styled.div `
  background-color: ${THEME.BORDER_STRONG};
  width: 19px;
  height: 19px;
  border-radius: 100%;
  position: absolute;
  top: -6px;
  right: -4px;
  color: ${THEME.COLOR_GREY};
  text-align: center;
  cursor: pointer;

  svg {
    height: 16px;
    width: 16px;
    margin: 1px 0px 1px;
  }
`;
//# sourceMappingURL=CreateUserOnCustomer.js.map